import { default_dashboard } from '@core/breadcrumbs';

const module = default_dashboard
  .extend('call-tracking.index')
  .add('call-tracking.breadcrumb.title', { name: 'call-tracking.index' });

const numbers_breadcrumbs = module
  .extend('call-tracking.number.index')
  .add('call-tracking.breadcrumb.number.index', { name: `call-tracking.number.index` });

const integration_breadcrumbs = module
  .extend('call-tracking.integration.index')
  .add('call-tracking.breadcrumb.integration.index', {
    name: `call-tracking.integration.index`
  });

const stats_breadcrumbs = module
  .extend('call-tracking.stats.index')
  .add('shared.breadcrumb.stats.title', { name: `call-tracking.stats.index` });

const call_tracking_breadcrumbs = [numbers_breadcrumbs, integration_breadcrumbs, stats_breadcrumbs];

export { call_tracking_breadcrumbs };
